import React, {useState, useContext, useEffect} from 'react';
import { IonText, IonGrid, IonRow, IonCol, IonButton, IonModal, IonImg, IonCheckbox } from '@ionic/react';

import { Auth_Zasava_Context } from '../../../storeState/Auth_Zasava_Context';

export function Restore_MercahntModal_Zasava(props) {

    let zasava_context = useContext(Auth_Zasava_Context);

    let [acctID, setAcctID] = useState(zasava_context.acctID);
    const [sessionID, setSessionID ] = useState(zasava_context.sessionID);
    let [baseURL, setBaseURL ] = useState(zasava_context.baseURL);

    //let [selectedFile, setSelectedFile] = useState(null);



    //useEffect(() => {

        //setSelectedFile1('/home/tkweifio/Documents/LocalKuaye/Forms/webApp/internal/zBackup/merchant_id_555_db_postgres_schema_hotel1_444_backup.dmp')

    //}, [])

    function submitRestoreRequest(tracker, selectedFile)
    {

        alert('In submitRestoreRequest');
        alert(tracker);
        alert(selectedFile);

        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            //body: JSON.stringify({formData})
            body: JSON.stringify({
                Tracker: tracker,
                user: acctID,
                xMerchantAccountID: props.data.merchantID,
                xMerchantSchema: props.data.merchantSchema,
                xSelectedFile: selectedFile,
                sessionID: sessionID
            })
        }

        
        fetch(baseURL+'/zsava_internal_indexApp', requestOptions)
        .then(res => res.text())
        .then(res => {

            alert(res);
        })
    }

    function submitRestoreDir(tracker, schema)
    {

        alert('In submitRestoreRequest');
        alert(tracker);
        alert(schema);

        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            //body: JSON.stringify({formData})
            body: JSON.stringify({
                Tracker: tracker,
                user: acctID,
                xMerchantAccountID: props.data.merchantID,
                xMerchantSchema: schema,
                sessionID: sessionID
            })
        }

        
        fetch(baseURL+'/zsava_internal_indexApp', requestOptions)
        .then(res => res.text())
        .then(res => {

            alert(res);
        })
    }

    function databaseSchemaRestoreHandler(e)
    {
        //setSelectedFile(e.target.files[0]);
    }

    function zasava_submitRestoreHandler(e)
    {
        alert('Inside zasava_submitRestoreHandler');

       submitRestoreRequest('9502Z_A_zasava', '/var/www/zBackup/zasava_db_postgres_schema_public_backup.dmp');
       submitRestoreRequest('9502Z_B_zasava', '/var/www/zBackup/zasava_db_qava_bank_info_schema_public_backup.dmp');
       //submitRestoreRequest('9502Z_C', '/home/tkweifio/Documents/LocalKuaye/Forms/webApp/internal/zBackup/zasava_db_qava_cash_auth_schema_public_backup.dmp');

    }

    function merchant_submitRestoreHandler(e)
    {
        alert('Inside merchant_submitRestoreHandler');

       submitRestoreRequest('9502A_zasava', '/var/www/zBackup/z_id_1_postgres_schema_zasava_001_backup.dmp');

       submitRestoreRequest('9502B_zasava', '/var/www/zBackup/z_id_1_db_schema_zasava_001_bank_info_backup.dmp');

       submitRestoreRequest('9502C_zasava', '/var/www/zBackup/z_id_1_db_schema_zasava_001_cash_nach_backup.dmp');

       submitRestoreDir('9502D_zasava', 'zasava_001');

    }

    function fileSystemRestoreHandler(e)
    {
        //setSelectedFile(e.target.files[0]);
    }

    function closeModalHandler(event) {

        props.closeModal(event);
    }

    //alert('Inside Modal_Resotre_Merchant');

    return (
        <React.Fragment>            
        {props.openModal == true ?
        (
            <div>
            {/* {ReactDOM.createPortal(<Backdrop />, document.getElementById('backdrop-root'))} */}

            <IonModal isOpen={ props.openModal }>

                <IonText> Restore Management </IonText>
                <IonGrid >
                    <IonRow >
                        <IonCol>
                            <form id='fileUpload' enctype='multipart/form-data'>
                                <label for='dbZasavaPublicSchemaRestore'>Perform Zasava Public Schema Restore  </label>
                                    <input id='dbZasavaPublicSchemaRestore' type='file' name='xDBFileSystemRestore' accept="dmp/*dd" onChange={(e) => databaseSchemaRestoreHandler(e)}></input>
                            </form>   
                        </IonCol>
                        <IonCol>
                            <IonButton onClick={() =>zasava_submitRestoreHandler()}> Submit Restore Zasava Public DB</IonButton>
                        </IonCol>
                    </IonRow>
                    <IonRow >
                        <IonCol>
                            <form id='fileUpload' enctype='multipart/form-data'>
                                <label for='dbSchemaRestore'>Perform Merchant Database Schema Restore </label>
                                    <input id='dbSchemaRestore' type='file' name='xDBSchemaRestore' accept="dmp/*" onChange={(e) => databaseSchemaRestoreHandler(e)}></input>
                            </form>   
                        </IonCol>
                        <IonCol>
                            <IonButton onClick={() =>merchant_submitRestoreHandler()}> Submit Restore DB Postgres Schema </IonButton>
                        </IonCol>
                    </IonRow>
                    
                    <IonRow >
                        <IonCol>
                            <form id='fileUpload' enctype='multipart/form-data'>
                                <label for='dbFileSystemRestore'>Perform File System Restore  </label>
                                    <input id='dbFileSystemRestore' type='file' name='xDBFileSystemRestore' accept="dmp/*" onChange={(e) => fileSystemRestoreHandler(e)}></input>
                            </form>   
                        </IonCol>
                        <IonCol>
                            <IonButton onClick={() =>submitRestoreRequest('9502D')}> Submit Restore File System </IonButton>
                        </IonCol>
                    </IonRow>
                </IonGrid>

                <IonButton onClick={() => closeModalHandler(false)}> Close </IonButton>
            </IonModal>            
        </div>
        ) : null }
    </React.Fragment>
    )
}